import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/Public/PublicLayout';
import RevealBlock from '../components/Public/RevealBlock';
import heroImage from '../assets/public/sections/home_hero_clean.jpg';
import aboutImageOne from '../assets/public/sections/home_about_1_clean.jpg';
import aboutImageTwo from '../assets/public/sections/home_about_2_clean.jpg';
import benefitsBackground from '../assets/public/sections/home_benefits_clean.jpg';
import certificationImage from '../assets/public/sections/home_cert_clean.jpg';
import '../styles/PublicSite.css';

const benefits = [
  'Palets de madera certificados NIMF-15 (HT)',
  'Fabricacion estandar y a medida',
  'Alta resistencia y durabilidad',
  'Experiencia, calidad y compromiso con el cliente',
  'Enfoque en seguridad y control de procesos',
  'Experiencia con clientes en Guatemala, El Salvador y Honduras',
];

const qualityHighlights = [
  'Procesos estandarizados por infraestructura certificada y control de calidad.',
  'Cumplimiento con normativas para tratamiento termico NIMF-15 (HT).',
  'Capacidad para produccion continua en pedidos regulares y especiales.',
  'Cumplimiento de seguridad industrial, resistencia y aseguramiento.',
  'Compromiso de mejora continua y certificacion BASC.',
];

const Home = () => {
  const handleDownloadCertification = () => {
    // Placeholder para integrar descarga real desde backend cuando el servicio este disponible.
    // eslint-disable-next-line no-console
    console.info('Descarga de certificacion lista para integracion backend.');
  };

  return (
    <PublicLayout>
      <div className="home-page">
        <section className="home-hero">
          <img src={heroImage} alt="Produccion de palets para exportacion" />
          <div className="home-hero-overlay" />
          <div className="home-hero-copy">
            <p>20 años de experiencia fabricando palets de madera certificados para exportacion</p>
          </div>
          <div className="home-hero-chip">
            <span className="home-hero-chip-year">20+</span>
            <span>Años exportando calidad</span>
          </div>
        </section>

        <RevealBlock className="home-section home-about" delay={90}>
          <h2>Sobre Maderas del Atlantico, S.A.</h2>

          <div className="home-about-grid">
            <figure>
              <img src={aboutImageOne} alt="Palets de madera" />
            </figure>
            <figure>
              <img src={aboutImageTwo} alt="Area de almacenamiento" />
            </figure>
            <article>
              <p>
                Maderas del Atlantico, S.A. nace en 2006 como una empresa comprometida con la
                fabricacion de palets de madera de alta calidad para el sector industrial y exportador.
                Actualmente contamos con infraestructura moderna en Km 12 ruta al Atlantico, Usumatlan,
                Zacapa.
              </p>
              <p>
                Hemos construido nuestra trayectoria sobre la base de trabajo constante, experiencia y la
                confianza de nuestros clientes.
              </p>
            </article>
          </div>

          <Link to="/sobre-nosotros" className="public-outline-button">
            Conocer mas <span aria-hidden="true">-></span>
          </Link>
        </RevealBlock>

        <section className="home-section home-benefits">
          <div className="home-green-title">
            <h2>Beneficios clave</h2>
          </div>

          <RevealBlock className="home-benefits-panel" delay={120}>
            <img src={benefitsBackground} alt="Sello de certificacion en madera" />
            <div className="home-benefits-overlay">
              <ul>
                {benefits.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </RevealBlock>

          <Link to="/productos" className="public-outline-button public-outline-inverse">
            Ver los productos <span aria-hidden="true">-></span>
          </Link>
        </section>

        <RevealBlock className="home-section home-certifications" delay={140}>
          <h2>Certificaciones y calidad</h2>

          <div className="home-certifications-grid">
            <figure>
              <img src={certificationImage} alt="Area de secado y control de calidad" />
            </figure>
            <article>
              <p>
                Nuestros procesos estan respaldados por infraestructura certificada, control de calidad
                constante y capacitaciones de personal.
              </p>
              <ul>
                {qualityHighlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          </div>

          <button type="button" className="public-outline-button cert-button" onClick={handleDownloadCertification}>
            Descargue la certificacion BASC 2026 aqui
          </button>

          <Link to="/contacto" className="public-outline-button home-contact-link">
            Ver informacion de contacto <span aria-hidden="true">-></span>
          </Link>
        </RevealBlock>
      </div>
    </PublicLayout>
  );
};

export default Home;
